import { gql } from '@apollo/client'

export const EventQuery = gql`
  query Event($companyId: ID!, $filters: EventFilters) {
    events(companyId: $companyId, filters: $filters) {
      nodes {
        id
        description
        details
        warehouse { id name address }
        state
        dateOut
        dateStart
        dateEnd
        dateReturn
        client { id organisationName clientType { name color } }
        venue { id name address }
        publicLink
      }
    }
  }
`
